export const linksAdminStrings = {
    loading: 'Loading links...',
    signedOut: 'Sign in to manage links and QR codes.',
    loginFailed: 'The username or password is incorrect.',
    requestFailed: 'The request could not be completed.',
    empty: 'No links yet. Create one above for a café card or an Instagram bio.',
    creating: 'Creating link...',
    created: (label: string) => `Created "${label}". Download its QR code below.`,
    archived: (label: string) => `Archived "${label}". Its address now opens the home page and is no longer counted.`,
    restored: (label: string) => `Restored "${label}".`,
    deleteConfirm: (label: string) => `Delete "${label}"? Its address and any printed QR code will open the home page, and this cannot be undone.`,
    deleted: (label: string) => `Deleted "${label}".`,
    targetUnavailable: 'That photograph cannot be chosen. Check that it still has a title.',
    copied: 'Link copied.',
    copyFailed: 'Copy failed. Select the address instead.',
    copy: 'Copy',
    copyLabel: (label: string) => `Copy the address for ${label}`,
    downloadQr: 'QR code',
    downloadQrLabel: (label: string) => `Download the QR code PNG for ${label}`,
    archive: 'Archive',
    restore: 'Restore',
    delete: 'Delete',
    deleteLabel: (label: string) => `Delete the link and QR code for ${label}`,
    archivedBadge: 'Archived',
    targetGroups: {
        page: 'Pages',
        collection: 'Collections',
        photo: 'Photographs',
        privateCollection: 'Private collections',
        privatePhoto: 'Private photographs'
    } as Record<string, string>,
    opens: (target: string) => `Opens ${target}`,
    targetGone: (path: string) => `Opens ${path}, which no longer exists, so scans go to the home page`,
    windows: [
        ['sevenDays', '7 days'],
        ['thirtyDays', '30 days'],
        ['ninetyDays', '90 days'],
        ['all', 'All kept']
    ] as const,
    legend: [
        ['Scans', 'Times the short address was opened: a QR code scanned or the link tapped. Each scan is counted, even from the same phone, and your own scans count too.'],
        ['Visits', 'Visitor sessions that arrived through the link, leaving out browsers you sign in to the admin from or excluded on the dashboard. A visitor already browsing the site in the same tab is moved to this link when they scan it.'],
        ['All kept', 'Scans and visits are kept for 90 days, like the rest of the visitor statistics, so older ones drop out of every column.'],
        ['Printing', 'The QR code is a high-resolution black-and-white PNG with a quiet border, made to survive a scuffed or partly covered card. Print it at least 2.5 cm (1 inch) across.'],
        ['Archiving', 'An archived link stops counting and sends anyone who scans it to the home page, so retire a card by archiving rather than reusing its code. Restoring it starts counting again.'],
        ['Private', 'A link can open a private photograph or collection without listing it anywhere public. A private photograph floats over the home page and fades away when closed instead of joining the wall; a private collection fills the home page for whoever scans the link.'],
        ['Deleting','Deleting removes a link for good. Its address then opens the home page like an archived link, but it cannot be restored, so archive a link you might want back.']
    ] as const
} as const;
